class OrderInformationCountdownController {
    constructor($interval, orderManagementService) {
        this.orderManagementService = orderManagementService;
        this.$interval = $interval;
    }

    $onInit() {
        this.updateFrequency = this.updateFrequency || 5000;
        this.minutesLeft = Math.max(0, this.minutesLeft);

        this.intervalPromise = this.$interval(() => {
            this.setTimeRemaining();
        }, this.updateFrequency);

        this.finalDate = new Date(Date.now() + Math.floor(parseFloat(this.minutesLeft) * 60000));
        this.setTimeRemaining();
    }

    $onDestroy() {
        this.$interval.cancel(this.intervalPromise);
    }

    setTimeRemaining() {
        let msec = this.finalDate.getTime() - Date.now();
        if (msec <= 0) {
            this.$interval.cancel(this.intervalPromise);
            this.orderManagementService.invalidate();
            this.orderManagementService.getOrders();
            msec = 0;
        }

        const hours = Math.floor(msec / 1000 / 60 / 60);
        msec -= hours * 1000 * 60 * 60;
        const mins = Math.floor(msec / 1000 / 60);
        msec -= mins * 1000 * 60;
        const secs = Math.floor(msec / 1000);

        const mm = mins < 10 ? `0${mins}` : mins;
        const ss = secs < 10 ? `0${secs}` : secs;

        this.hours = `${hours}`;
        this.mins = `${mm}`;
        this.secs = `${ss}`;
        this.srTimeString = `${hours} hours, ${mins} minutes, and ${secs} seconds`;
        this.minutesLeft -= this.updateFrequency / 60000;
        if (this.minutesLeft <= 0) {
            this.minutesLeft = 0;
        }
    }

}

const orderInformationCountdownComponentDefinition = {
    bindings: {
        minutesLeft: '=',
        updateFrequency: '=?',
        classModifier: '@?',
    },
    controller: ['$interval', 'OrderManagementService', OrderInformationCountdownController],
    template: require('./order-information-countdown.component.html').trim(),
};

module.exports = {
    OrderInformationCountdownController,
    orderInformationCountdownComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/orderinformation/order-information-countdown.component.js